import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { Editable, Slate, withReact } from '@seafile/slate-react';
import { createEditor, Editor } from 'slate';
import { renderNode, renderLeaf, decorationNode } from '../containers/render-utils/viewer-utils';
import { withBlock, withInline, withVoid } from '../containers/controller';
import '../containers/code-highlight-package';
var SlateViewer = /*#__PURE__*/function (_React$Component) {
  _inherits(SlateViewer, _React$Component);
  var _super = _createSuper(SlateViewer);
  function SlateViewer(props) {
    var _this;
    _classCallCheck(this, SlateViewer);
    _this = _super.call(this, props);
    _this.onChange = function () {
      // nothing todo
    };
    _this.scrollToNode = function (node) {
      var editor = document.querySelector('.viewer-component');
      var element = editor.childNodes[node.path[0]];
      _this.editorContainerRef.scrollTo(0, element.offsetTop);
      window.location.hash = encodeURI(node.children[0].text);
      Editor.select(_this.editor, node.path);
    };
    _this.setEditorContainerRef = function (ref) {
      _this.editorContainerRef = ref;
    };
    _this.slateEditor = withVoid(withBlock(withInline(withReact(createEditor()))));
    window.viewer = _this.slateEditor;
    return _this;
  }
  _createClass(SlateViewer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.abcdef_editor = this;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.slateEditor = null;
      window.abcdef_editor = null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        value = _this$props.value,
        renderDiffElement = _this$props.renderDiffElement,
        renderDiffLeaf = _this$props.renderDiffLeaf;
      return /*#__PURE__*/React.createElement(Slate, {
        editor: this.slateEditor,
        value: value,
        onChange: this.onChange
      }, /*#__PURE__*/React.createElement("div", {
        className: "article",
        ref: this.setEditorContainerRef
      }, /*#__PURE__*/React.createElement(Editable, {
        readOnly: true,
        className: 'viewer-component',
        decorate: decorationNode,
        renderElement: renderDiffElement ? renderDiffElement : renderNode,
        renderLeaf: renderDiffLeaf ? renderDiffLeaf : renderLeaf
      })));
    }
  }]);
  return SlateViewer;
}(React.Component);
export default SlateViewer;